import { render, staticRenderFns } from "./SaveCancelButtons.vue?vue&type=template&id=3b5f4c5d&"
import script from "./SaveCancelButtons.vue?vue&type=script&lang=js&"
export * from "./SaveCancelButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports